const ISI_PLAY_HTTPS_BASE = "https://video.isilive.ca/play/";
const ISI_PLAY_HTTP_BASE = "http://video.isilive.ca/play/";
const LINX_LIVE_URL_REGEX =
  /^https?:\/\/linx\.isilive\.ca\/live\/(.+?)\/index\.m3u8(?:\?.*)?$/i;

const trimSlashes = (value) => value.replace(/^\/+|\/+$/g, "");

export const normalizeToIsiPlayUrl = (value) => {
  if (typeof value !== "string") return "";

  const trimmed = value.trim();
  if (!trimmed) return "";

  if (trimmed.startsWith(ISI_PLAY_HTTPS_BASE)) {
    return trimmed;
  }

  if (trimmed.startsWith(ISI_PLAY_HTTP_BASE)) {
    return `${ISI_PLAY_HTTPS_BASE}${trimmed.slice(ISI_PLAY_HTTP_BASE.length)}`;
  }

  const linxMatch = trimmed.match(LINX_LIVE_URL_REGEX);
  if (linxMatch) {
    return `${ISI_PLAY_HTTPS_BASE}${trimSlashes(linxMatch[1])}`;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `${ISI_PLAY_HTTPS_BASE}${trimSlashes(trimmed)}`;
};

export const extractIsiPlayPath = (value) => {
  const normalized = normalizeToIsiPlayUrl(value);
  if (!normalized.startsWith(ISI_PLAY_HTTPS_BASE)) return "";

  try {
    const parsed = new URL(normalized);
    const withoutPrefix = parsed.pathname.replace(/^\/+/, "").replace(/^play\//i, "");
    return trimSlashes(withoutPrefix);
  } catch {
    return trimSlashes(normalized.slice(ISI_PLAY_HTTPS_BASE.length).split("?")[0]);
  }
};

export const withQueryParam = (url, key, value) => {
  if (!url) return "";

  try {
    const parsed = new URL(url);
    parsed.searchParams.set(key, value);
    return parsed.toString();
  } catch {
    return url;
  }
};

export const buildIsiPlayerUrl = (value) => {
  const normalized = normalizeToIsiPlayUrl(value);
  if (!normalized.startsWith(ISI_PLAY_HTTPS_BASE)) return normalized;
  return withQueryParam(normalized, "auto_hide", "true");
};
